import { render, staticRenderFns } from "./Cupones.vue?vue&type=template&id=22cb39c0"
import script from "./Cupones.vue?vue&type=script&lang=js"
export * from "./Cupones.vue?vue&type=script&lang=js"
import style0 from "./Cupones.vue?vue&type=style&index=0&id=22cb39c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports